import { z } from 'zod'
import { AreaCodeSchema, ContractStatusSchema, PremiumFrequencySchema } from '../enums.js'

export const ContractScanSchema = z.object({
  // Nullable so contracts uploaded before migration 0006 (which only have
  // raw_scan_r2_key set, no filename/mime/bytes) can still be served — the
  // download endpoint falls back to "scan" + application/octet-stream and
  // the FE renders a generic download row.
  filename: z.string().nullable(),
  mime_type: z.string().nullable(),
  bytes: z.number().nonnegative().nullable(),
  url: z.string(),
})
export type ContractScan = z.infer<typeof ContractScanSchema>

export const ContractSchema = z.object({
  id: z.string().min(1),
  family_id: z.string().min(1),
  insurer: z.string().min(1),
  type: AreaCodeSchema,
  holder_member_id: z.string().min(1),
  insured_member_ids: z.array(z.string().min(1)),
  premium_czk: z.number().nonnegative(),
  valid_from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  valid_to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  contract_number: z.string().optional(),
  premium_frequency: PremiumFrequencySchema.optional(),
  auto_renewal: z.boolean().nullable().optional(),
  renewal_notice_days: z.number().int().nonnegative().nullable().optional(),
  status: ContractStatusSchema,
  created_at: z.string(),
  // Optional + nullable: existing API responses that predate the scan
  // endpoint don't need to include this field at all; once shipped, the
  // route layer sets it to a ContractScan object or explicitly to null
  // when the contract has no stored scan.
  scan: ContractScanSchema.nullable().optional(),
})
export type Contract = z.infer<typeof ContractSchema>
